import ErrorIcon from '@mui/icons-material/Error';
import { TransparencyIconButton } from '@/components/viewOption/icon-renderers/TransparencyIcon';
import type { Transparency } from '@/engine/app/interfaces.ts';
import { type FC } from 'react';
import type { WithMixed, WithUndefined } from '../types';

export const TransparencyIconRender: FC<{
  transparency: WithMixed<WithUndefined<Transparency>>;
  onClick: (transparency: Transparency) => void;
}> = (props) => {
  if (props.transparency === undefined) {
    return <ErrorIcon />;
  }

  return (
    <TransparencyIconButton
      transparency={props.transparency}
      onChange={(transparency): void => props.onClick(transparency)}
    />
  );
};
